import React from 'react';

import { Link } from 'react-router-dom';
import NoPermissionToViewReportImage from 'styles/assets/png/NoPermissionToViewReport.png';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import classes from 'components/common/ErrorPages/ErrorPages.module.scss';

export const NoPermissionToViewReport = () => {
    return (
        <div className={classes.message}>
            <img
                src={NoPermissionToViewReportImage}
                className={classes.notFoundImage}
                alt={'No permission to view report'}
            />
            <div className={classes.description}>
                <h1>You don’t have access to this Report</h1>
                <h2>
                    Either this report is private, or you don’t have access to the project data that is powering it.
                </h2>
            </div>
            <div>
                <Link to={AppRoutes.buildPath(AppRoutes.DASHBOARD_REPORTING_PATH)}>Go to Reports</Link> or{' '}
                <Link to={'/'}>Go to homepage</Link>
            </div>
        </div>
    );
};
